import { Heart } from "lucide-react";

export const Footer = () => (
  <footer className="bg-white border-t border-slate-200 mt-16" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <span className="eq-bars" style={{ height: 16 }} aria-hidden="true"><span /><span /><span /><span /><span /></span>
        <span className="font-display font-black text-sm">MusicPulse<span className="gradient-text">.pro</span></span>
        <span className="text-xs text-slate-500 ml-2 hidden md:inline">A More Musical, More Connected World.</span>
      </div>
      <div className="flex items-center gap-1.5 text-xs text-slate-500">
        Music Unites · Cultures Inspire · People Belong
        <Heart className="w-3.5 h-3.5 text-pink-500 fill-pink-500" />
      </div>
    </div>
  </footer>
);

export default Footer;
